import React, { useRef } from "react";
import { useInView } from "../hooks/useInView";
import { meetDarenContent } from "../data/mock";

export const MeetDaren = () => {
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { threshold: 0.1 });

  return (
    <section
      id="meet-daren"
      ref={sectionRef}
      className="section-padding relative"
      style={{ backgroundColor: "#F5F0E8" }}
    >
      <div className="max-w-7xl mx-auto">
        <div className="max-w-3xl mx-auto">
          {/* Section Header */}
          <div
            className={`mb-10 ${
              isInView ? "animate-fade-in-up" : "opacity-0"
            }`}
          >
            <span className="text-gold text-sm font-semibold tracking-widest uppercase mb-4 block">
              Meet Your DJ
            </span>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-charcoal">
              {meetDarenContent.title}
            </h2>
          </div>

          {/* Content */}
          <div
            className={`space-y-5 ${
              isInView ? "animate-fade-in-up" : "opacity-0"
            }`}
            style={{ animationDelay: "200ms", animationFillMode: "both" }}
          >
            {meetDarenContent.paragraphs.map((paragraph, index) => (
              <p
                key={index}
                className="text-charcoal/65 text-lg leading-relaxed"
              >
                {paragraph}
              </p>
            ))}
          </div>

          <p
            className={`text-gold font-medium text-sm tracking-wide mt-6 ${
              isInView ? "animate-fade-in-up" : "opacity-0"
            }`}
            style={{ animationDelay: "350ms", animationFillMode: "both" }}
          >
            Denver based wedding DJ serving Colorado's most memorable celebrations.
          </p>

          {/* Signature line */}
          <div
            className={`mt-10 pt-8 border-t border-charcoal/10 ${
              isInView ? "animate-fade-in-up" : "opacity-0"
            }`}
            style={{ animationDelay: "400ms", animationFillMode: "both" }}
          >
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-full bg-gold/15 flex items-center justify-center">
                <span className="text-gold font-display font-bold text-lg">D</span>
              </div>
              <div>
                <div className="font-display text-lg font-semibold text-charcoal">
                  Daren
                </div>
                <div className="text-sm text-charcoal/50">
                  Founder & DJ, Lobben Event Co.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
